import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveResourceGroup(
  state: State,
  group: Boundaries["removeResourceGroup"]["success"],
): State {
  return state.map((res) => ({
    ...res,
    groups: res.groups.filter(({ uuid }) => group.uuid !== uuid),
  }));
}

export { handleRemoveResourceGroup };
